import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

// Variabile per tenere traccia dei ScrollTrigger di cantScroll
let cantScrollTriggers = [];
// Flag per disabilitare l'auto-scroll se arriviamo dal Swiper
let disableAutoScroll = false;

// Funzione per disabilitare temporaneamente le ottimizzazioni CSS per le animazioni cantina
function disablePerformanceOptimizations() {
  const elements = document.querySelectorAll('.wrapper-transition, .space-transition, .next-cantina-preview, .preview-logo, .next-hero-bg, .pin-spacer');
  elements.forEach(el => {
    if (el) {
      el.style.contain = 'none';
      el.style.willChange = 'auto';
      el.style.transform = 'none';
      el.style.backfaceVisibility = 'visible';
      el.style.perspective = 'none';
    }
  });
}

// Funzione per riabilitare le ottimizzazioni CSS dopo le animazioni cantina
function enablePerformanceOptimizations() {
  const elements = document.querySelectorAll('.wrapper-transition, .space-transition, .next-cantina-preview, .preview-logo, .next-hero-bg, .pin-spacer');
  elements.forEach(el => {
    if (el) {
      el.style.contain = '';
      el.style.willChange = '';
      el.style.transform = '';
      el.style.backfaceVisibility = '';
      el.style.perspective = '';
    }
  });
}

// Funzione per disabilitare/pulire cantScroll
export function disableCantScroll() {
  //console.log('🚫 Disabilitazione cantScroll...');
  cantScrollTriggers.forEach(trigger => {
    if (trigger && trigger.kill) {
      trigger.kill();
    }
    // Rimuovi il listener per i click se presente
    if (trigger && trigger._clickHandler) {
      document.removeEventListener('click', trigger._clickHandler, true);
      delete trigger._clickHandler;
    }
  });
  cantScrollTriggers = [];
}

// Funzione per riattivare cantScroll dopo che è stato disabilitato
export function reactivateCantScroll(swupInstance) {
  //console.log('🔄 Riattivazione cantScroll...');
  // Prima disabilita eventuali trigger esistenti
  disableCantScroll();
  // Poi reinizializza completamente
  initCantScroll(swupInstance);
}

// Funzione per disabilitare l'auto-scroll (per navigazioni dal Swiper)
export function setDisableAutoScroll(disabled) {
  disableAutoScroll = disabled;
  //console.log('🚫 Auto-scroll disabilitato:', disabled);
}

// Funzione per inizializzare solo gli elementi base (colore footer, layout) senza auto-scroll
export function initCantinaBasics() {
  //console.log('🎨 Inizializzazione elementi base cantina...');

  // VERIFICA CRITICA: siamo su una pagina cantina?
  const mainEl = document.querySelector("main.cantina-single");
  if (!mainEl) {
    return;
  }

  // IMPORTANTE: Ripristina sempre l'opacity del .cantina-hero
  // Questo risolve problemi con back/forward del browser
  const cantinaHero = document.querySelector('.cantina-hero');
  if (cantinaHero) {
    const currentOpacity = parseFloat(getComputedStyle(cantinaHero).opacity);
    if (currentOpacity < 0.5) {
      console.log('🏷️ initCantinaBasics: Ripristino opacity cantina-hero (era', currentOpacity, ')');
      gsap.set(cantinaHero, { opacity: 1, visibility: 'visible' });
    }
  }

  // Recupera colore cantina
  let cantinaColor = getComputedStyle(document.body).getPropertyValue('--cantina-color').trim();

  if (!cantinaColor) {
    cantinaColor = getComputedStyle(mainEl).getPropertyValue('--cantina-color').trim();
  }

  if (!cantinaColor) {
    cantinaColor = '#c7c0b7';
  }

  // Applica il colore della cantina al footer
  const footerDiv = document.getElementById('site-footer');
  if (footerDiv && cantinaColor) {
    gsap.set(footerDiv, {
      backgroundColor: cantinaColor
    });
    //console.log('🎨 Colore footer applicato:', cantinaColor);
  }

  // Calcolo e impostazione altezza wrapper-transition se presente
  function adjustWrapperHeight() {
    const wrapper = document.querySelector('.wrapper-transition');
    const spaceTransition = document.querySelector('.space-transition');
    if (!wrapper || !spaceTransition) return;

    const viewportHeight = window.innerHeight;
    const extraScrollSpace = 600; // Spazio extra dopo che curtain raggiunge 100%
    const minHeight = viewportHeight + spaceTransition.clientHeight + extraScrollSpace;

    wrapper.style.minHeight = `${minHeight}px`;
    //console.log('📏 Altezza wrapper aggiustata');
  }

  adjustWrapperHeight();

  // enableScroll() rimosso - lo scroll viene gestito centralmente dal custom-theme.js
}

export function initCantScroll(swupInstance) {
  if (!swupInstance) return;

  // Verifica che ScrollTrigger sia disponibile
  if (!ScrollTrigger) {
    //console.warn('ScrollTrigger non disponibile in cantScroll');
    return;
  }

  gsap.registerPlugin(ScrollTrigger);

  // IMPORTANTE: Forza il refresh di ScrollTrigger prima di killare tutti i trigger
  ScrollTrigger.refresh();
  ScrollTrigger.getAll().forEach(t => t.kill());

  // IMPORTANTE: Ripristina sempre l'opacity del .cantina-hero all'inizio
  // Questo risolve problemi con back/forward del browser
  const cantinaHero = document.querySelector('.cantina-hero');
  if (cantinaHero) {
    const currentOpacity = parseFloat(getComputedStyle(cantinaHero).opacity);
    if (currentOpacity < 0.5) {
      console.log('🏷️ cantScroll: Ripristino opacity cantina-hero (era', currentOpacity, ')');
      gsap.set(cantinaHero, { opacity: 1, visibility: 'visible' });
    }
  }

  // Se l'auto-scroll è disabilitato, inizializza solo gli elementi base
  if (disableAutoScroll) {
    //console.log('🚫 cantScroll: Auto-scroll disabilitato, inizializzo solo elementi base');
    initCantinaBasics();

    // Aggiungi listener per riattivare l'auto-scroll quando l'utente fa scroll manuale
    const handleScroll = () => {
      //console.log('🔄 Scroll manuale rilevato - riattivo auto-scroll');
      setDisableAutoScroll(false);
      window.removeEventListener('scroll', handleScroll);
      // Reinizializza cantScroll con auto-scroll abilitato
      setTimeout(() => initCantScroll(swupInstance), 100);
    };

    window.addEventListener('scroll', handleScroll, { once: true });
    return;
  }

  // VERIFICA CRITICA: siamo su una pagina cantina?
  const mainEl = document.querySelector("main.cantina-single");
  if (!mainEl) {
    //console.log('🚫 cantScroll: Non siamo su una pagina cantina');
    return;
  }

  const nextUrl = mainEl?.dataset.nextUrl;
  if (!nextUrl) {
    //console.log('🚫 cantScroll: nextUrl non trovato nel dataset');
    return;
  }

  // Verifica se la prossima pagina è una cantina (supporta /cantine/ e /wineries/)
  const isNextPageCantina = nextUrl.includes('/cantine/') || nextUrl.includes('/wineries/');
  if (!isNextPageCantina) {
    //console.log('🚫 cantScroll: La prossima pagina non è una cantina:', nextUrl);
    return;
  }

  //console.log('✅ cantScroll: Inizializzazione possibile, nextUrl:', nextUrl);

  // Verifica che gli elementi essenziali esistano
  const wrapperTransition = document.querySelector('.wrapper-transition');
  if (!wrapperTransition) {
    //console.warn('cantScroll: .wrapper-transition non trovato, uscita anticipata');
    return;
  }

  let loading = false;
  let progressBarComplete = false;
  let shouldTriggerTransition = false;

  // 1. Cerca sul body (primo candidato)
  let cantinaColor = getComputedStyle(document.body).getPropertyValue('--cantina-color').trim();

  // 2. Se non trovato, cerca su cantina-single
  if (!cantinaColor) {
    cantinaColor = getComputedStyle(mainEl).getPropertyValue('--cantina-color').trim();
  }

  // 3. Fallback se non trovato
  if (!cantinaColor) {
    cantinaColor = 'red';
  }

  // bgcolor img footer
  const footerDiv = document.getElementById('site-footer');

  // Applico il colore della cantina al footer
  if (footerDiv && cantinaColor) {
    gsap.set(footerDiv, {
      backgroundColor: cantinaColor
    });
  }

  // calcolo e impostazione altezza wrapper-transition
  function adjustWrapperHeight() {
    const wrapper = document.querySelector('.wrapper-transition');
    const spaceTransition = document.querySelector('.space-transition');
    if (!wrapper || !spaceTransition) return;

    // calcolo altezza minima basata sulla viewport e contenuto
    const viewportHeight = window.innerHeight;
    const extraScrollSpace = 600; // Spazio extra dopo che curtain raggiunge 100%
    const minHeight = viewportHeight + spaceTransition.clientHeight + extraScrollSpace;

    wrapper.style.minHeight = `${minHeight}px`;

    // NUOVO: Assicurati che body e html abbiano scroll abilitato
    document.body.style.overflow = '';
    document.documentElement.style.overflow = '';

    // NUOVO: Forza un reflow per assicurarsi che il browser riconosca i cambiamenti
    void wrapper.offsetHeight;

    return minHeight; // Ritorna l'altezza per eventuali debug
  }

  // calcolo altezze iniziali
  const calculatedHeight = adjustWrapperHeight();
  console.log('📏 Wrapper height calcolata:', calculatedHeight);

  // gestore resize per ricalcolare altezze
  function resizeHandler() {
    adjustWrapperHeight();
    // NUOVO: Usa requestAnimationFrame per assicurarsi che il refresh avvenga dopo il reflow
    requestAnimationFrame(() => {
      if (window.ScrollTrigger && ScrollTrigger.refresh) {
        ScrollTrigger.refresh(true);
      }
    });
  }
  window.addEventListener('resize', resizeHandler);

  // force refresh scrolltrigger per evitare bug
  setTimeout(() => {
    if (window.ScrollTrigger && ScrollTrigger.refresh) {
      ScrollTrigger.refresh(true); // true = force
      console.log('🔄 ScrollTrigger refreshed');
    }
  }, 100);

  // NUOVO: Aggiungi un secondo refresh dopo che tutto si è stabilizzato
  setTimeout(() => {
    if (window.ScrollTrigger && ScrollTrigger.refresh) {
      ScrollTrigger.refresh(true);
      console.log('🔄 ScrollTrigger refreshed (secondo check)');
    }
  }, 500);

  const spaceTransitionEl = document.querySelector('.space-transition');

  // Verifica aggiuntiva: se non ci sono elementi essenziali, esci
  if (!spaceTransitionEl) {
    //console.warn('cantScroll: .space-transition non trovato, uscita anticipata');
    return;
  }

  // Inizializza l'immagine hero della prossima cantina con curtain reveal
  const nextHeroBg = document.querySelector('.next-hero-bg');
  let curtain = null;
  let opacitySet = false; // Flag per impostare opacity una sola volta

  if (nextHeroBg) {
    // Crea o recupera l'elemento curtain
    curtain = nextHeroBg.querySelector('.curtain-reveal');
    if (!curtain) {
      curtain = document.createElement('div');
      curtain.className = 'curtain-reveal';
      curtain.style.cssText = `
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: ${cantinaColor};
        transform: translateY(0%) translateZ(0);
        will-change: transform;
        backface-visibility: hidden;
        contain: layout style paint;
        z-index: 1;
      `;
      nextHeroBg.appendChild(curtain);
    } else {
      // Aggiorna solo il colore e assicura la posizione iniziale
      curtain.style.backgroundColor = cantinaColor;
      curtain.style.transform = 'translateY(0%) translateZ(0)';
      curtain.style.willChange = 'transform';
      curtain.style.backfaceVisibility = 'hidden';
      curtain.style.contain = 'layout style paint';
    }

    // Ottimizza anche il container nextHeroBg
    nextHeroBg.style.willChange = 'opacity';
    nextHeroBg.style.contain = 'layout style paint';

    // L'opacity verrà impostata a 1 nel primo frame di ScrollTrigger onUpdate
    // Questo garantisce che la curtain sia confermata in posizione prima di mostrare l'immagine
    gsap.set(nextHeroBg, {
      opacity: 0, // Inizia invisibile
      force3D: true
    });

    //console.log('✅ cantScroll: next-hero-bg con curtain pronta (colore:', cantinaColor, ')');
  }

  // Cache elementi DOM per performance
  const progressBar = document.querySelector(".scroll-progress-bar");
  const pinSpacer = document.querySelector('.pin-spacer');
  const cantLogos = document.querySelectorAll('.cant-logos .cantina-logo');

  // Cache elementi interattivi per evitare di cercarli ogni volta
  const wrapperInteractiveElements = wrapperTransition ?
    Array.from(wrapperTransition.querySelectorAll('a, button, [data-frecc], .cantina-logo-link')) : [];
  const spaceInteractiveElements = spaceTransitionEl ?
    Array.from(spaceTransitionEl.querySelectorAll('a, button, [data-frecc], .cantina-logo-link')) : [];

  // Pre-cache loghi con rilevamento automatico tipo (PNG o SVG)
  const logosCache = [];
  cantLogos.forEach(logo => {
    const logoType = logo.dataset.logoType; // 'png' o 'svg'

    if (logoType === 'png') {
      // Per PNG: cache solo il layer accent (molto più performante!)
      const accentLayer = logo.querySelector('.logo-accent');
      logosCache.push({
        type: 'png',
        element: logo,
        accentLayer: accentLayer,
        isActive: logo.classList.contains('active'),
        isNextActive: logo.classList.contains('next-active')
      });
    } else {
      // Per SVG: cache paths come prima (fallback legacy)
      const svgPaths = logo.querySelectorAll('svg path');
      logosCache.push({
        type: 'svg',
        element: logo,
        paths: svgPaths,
        isActive: logo.classList.contains('active'),
        isNextActive: logo.classList.contains('next-active')
      });
    }
  });

  // Pre-calcola i colori per SVG (usati solo se ci sono SVG)
  const accentColor = 'rgba(255, 255, 255, 1)';
  const originalColor = 'rgba(255, 255, 255, 0.2)';

  // Sistema di caching per ultimo valore curtain (evita ridondanza)
  let lastCurtainPercent = -1;
  let lastProgressPercent = -1;

  // Calcola il fattore di accelerazione per la curtain
  // La curtain deve raggiungere 100% PRIMA della fine dello scroll (600px prima)
  const extraScrollSpace = 600;
  const wrapperHeight = wrapperTransition.offsetHeight;
  const viewportHeight = window.innerHeight;
  const totalScrollDistance = wrapperHeight - viewportHeight;
  const curtainCompleteDistance = totalScrollDistance - extraScrollSpace;
  const curtainAccelerationFactor = totalScrollDistance / curtainCompleteDistance;

  // console.log('📊 Curtain config:', {
  //   wrapperHeight,
  //   viewportHeight, 
  //   totalScrollDistance,
  //   curtainCompleteDistance,
  //   accelerationFactor: curtainAccelerationFactor.toFixed(2)
  // });

  // Pulisci i trigger esistenti prima di crearne di nuovi
  disableCantScroll();

  // Estrai la logica di transizione in una funzione separata per poterla chiamare manualmente
  const handleTransition = () => {
    // Se la transizione deve essere attivata dalla barra di progresso, controlla che sia completa
    if (!shouldTriggerTransition && !progressBarComplete) {
      // Se la barra non è ancora completa, non attivare la transizione
      return;
    }

    if (loading) return;

    loading = true;

    // Lo scroll è già stato disabilitato centralmente in animation:out:start

    // AGGIORNA SUBITO il theme-color per iOS Liquid Glass
    // Recupera il colore della PROSSIMA cantina da .space-transition
    // console.log('🎨 [cantScroll:onLeave] Inizio transizione scroll cantina');
    // console.log('🎨 [cantScroll:onLeave] spaceTransitionEl:', spaceTransitionEl);
    // console.log('🎨 [cantScroll:onLeave] dataset.nextBgColor:', spaceTransitionEl?.dataset?.nextBgColor);

    const nextCantinaColor = spaceTransitionEl?.dataset?.nextBgColor?.trim();
    // console.log('🎨 [cantScroll:onLeave] nextCantinaColor (trimmed):', nextCantinaColor);
    // console.log('🎨 [cantScroll:onLeave] window.updateThemeColor:', typeof window.updateThemeColor);

    if (nextCantinaColor && window.updateThemeColor) {
      //console.log('🎨 [cantScroll:onLeave] Chiamando updateThemeColor...');
      window.updateThemeColor(nextCantinaColor, 'cantScroll:onLeave (scroll transition)');
    } else {
      console.warn('🎨 [cantScroll:onLeave] ⚠️ NON chiamata updateThemeColor - nextCantinaColor:', nextCantinaColor, '- window.updateThemeColor:', typeof window.updateThemeColor);
    }

    // Preparo tutti gli elementi necessari
    const pinSpacer = document.querySelector('.pin-spacer');
    const wrapper = document.querySelector('.wrapper-transition');
    const transitionSpace = document.querySelector('.space-transition');
    const progressBar = document.querySelector('.scroll-progress');
    const progressTitle = document.querySelector('.infinite-preview h4');
    const cantLogos = document.querySelector('.cant-logos');
    const heroMirror = document.querySelector('.cantina-hero-mirror');
    const containerBottom = document.querySelector('#site-footer .wrapper-transition .container-bottom');
    const nextCantinaPreview = document.querySelector('.next-cantina-preview');
    const imgFooter = document.querySelector('.img-footer');
    const nextLayer = document.querySelector('.next-cantina-layer');

    if (!wrapper || !transitionSpace) return;

    // Lo scroll è già bloccato centralmente, non serve chiamare di nuovo disableScroll()

    // Preserva esplicitamente l'immagine .next-hero-bg durante la transizione
    const nextHeroBg = document.querySelector('.next-hero-bg');
    let nextHeroBgClone = null;

    if (nextHeroBg) {
      // Crea un clone indipendente per la transizione
      nextHeroBgClone = nextHeroBg.cloneNode(true);
      nextHeroBgClone.id = 'next-hero-bg-transition-clone';
      nextHeroBgClone.className = 'next-hero-bg-transition-clone';

      // Copia le proprietà computate correnti
      const computedStyle = getComputedStyle(nextHeroBg);
      const currentBgImage = computedStyle.backgroundImage;
      const currentOpacity = computedStyle.opacity;
      // Imposta il clone dell'immagine hero
      // CRITICO: z-index alto ma inferiore a next-cantina-preview (9999999) per evitare flash bianco
      gsap.set(nextHeroBgClone, {
        opacity: 1, // Sempre visibile durante la transizione
        zIndex: 9999998, // Alto ma inferiore a next-cantina-preview (9999999)
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        pointerEvents: 'none',
        backgroundImage: currentBgImage,
        backgroundSize: 'cover',
        backgroundPosition: 'center center',
        backgroundRepeat: 'no-repeat',
        willChange: 'opacity' // Ottimizzazione per animazioni
      });

      // Aggiungi il clone al body
      document.body.appendChild(nextHeroBgClone);
    }

    // Il logo rimane sempre visibile e aggiusto la posizione
    if (heroMirror) {
      gsap.set(heroMirror, {
        opacity: 1,
        y: 5
      });
    }

    // Disabilita le ottimizzazioni CSS per permettere le animazioni cantina
    disablePerformanceOptimizations();

    // Creo una timeline unificata per tutte le animazioni
    const tl = gsap.timeline({
      onStart: () => {
        // Assicurati che le ottimizzazioni siano disabilitate all'inizio
        disablePerformanceOptimizations();
      },
      onComplete: () => {
        const nextUrlPath = new URL(nextUrl, location.origin).pathname;
        // Verifica se è una cantina singola (non archivio) - supporta /cantine/ e /wineries/
        const isArchive = /\/cantine\/?$/.test(nextUrlPath) || /\/wineries\/?$/.test(nextUrlPath);
        const isCantina = (nextUrlPath.includes('/cantine/') || nextUrlPath.includes('/wineries/')) && !isArchive;

        window._swupNav = {
          href: nextUrl,
          insideSwiper: false,
          isCantina: isCantina, // Solo cantine singole, non archivio
          allowCantina: true, // forziamo l'attivazione per lo scroll–based transition
          isCantinaSwiper: false // NON è dal swiper, è da scroll
        };
        Promise.resolve(swupInstance.navigate(nextUrl, { history: true }))
          .then(() => {
            // Usa la funzione globale forceScrollToTop se disponibile, altrimenti fallback
            if (window.forceScrollToTop) {
              window.forceScrollToTop();
            } else {
              window.scrollTo(0, 0);
              document.documentElement.scrollTop = 0;
              document.body.scrollTop = 0;
            }
            // Riabilita le ottimizzazioni dopo la navigazione
            setTimeout(() => enablePerformanceOptimizations(), 100);
          })
          .catch(console.error);
      }
    });

    // Mantieni il clone .next-hero-bg visibile durante tutta la transizione
    tl.set(nextHeroBgClone, {
      opacity: 1,
      zIndex: 99996,
      display: 'block'
    })
      .to(progressBar, {
        opacity: 0,
        duration: 0.1,
        ease: 'power3.easeOut'
      }, '-=0.1')
      .to(cantLogos, {
        opacity: 0,
        duration: 0.4,
        ease: 'power2.easeOut'
      }, '-=0.2')
      // Anima wrapper e transitionSpace separatamente dal pinSpacer
      .to([wrapper, transitionSpace], {
        duration: 0.4, // Ridotto da 0.55 a 0.4
        ease: 'power3.easeOut',
        position: 'fixed',
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 99997,
        height: '100vh',
        overflow: 'visible',
        onStart: () => {
          if (containerBottom) gsap.set(containerBottom, { autoAlpha: 0 });
          if (imgFooter) {
            gsap.to(imgFooter, {
              duration: 0.15, // Ridotto da 0.2 a 0.15
              ease: 'power3.easeOut',
              opacity: 0,
              zIndex: 5
            });
          }
          // RIMUOVO l'animazione di nextCantinaPreview da qui - la sposterò più avanti
        },
      })
      // Anima il pinSpacer separatamente (senza proprietà background) solo se esiste
      .add(() => {
        if (pinSpacer) {
          gsap.to(pinSpacer, {
            duration: 0.4, // Ridotto da 0.55 a 0.4
            ease: 'power3.easeOut',
            position: 'fixed',
            left: 0,
            right: 0,
            bottom: 0,
            top: 0,
            zIndex: 99993, // Leggermente sotto agli altri elementi
            width: '100vw',
            height: '100vh',
            opacity: 1,
          });
        }
      }, '-=0.3') // Ridotto da -0.45 a -0.3 per sovrapporre di più
      .set([wrapper, transitionSpace], {
        top: 0,
      })
      .add(() => {
        if (pinSpacer) {
          gsap.set(pinSpacer, { top: 0 });
        }
      })
      // Anima progress bar e title solo se esistono
      .add(() => {
        const elementsToHide = [progressBar, progressTitle].filter(el => el);
        //console.log('🏷️ elementsToHide:', elementsToHide);
        if (elementsToHide.length > 0) {
          gsap.to(elementsToHide, {
            opacity: 0,
            duration: 0.15,
            ease: 'power3.easeOut',
          });
        }
      }, '-=0.15') // Ridotto da -0.2 a -0.15
      .to(transitionSpace, {
        duration: 0.15,
        ease: 'power3.easeOut',
        transform: 'translateY(0)',
        onStart: () => {
          // Aggiungo la classe active per mostrare l'hero mirror
          transitionSpace.classList.add('active');
        }
      }, '-=0.15') // Ridotto da -0.2 a -0.15
      .add(() => {
        if (nextLayer) {
          gsap.set(nextLayer, { zIndex: 999999 });
          gsap.to(nextLayer, { autoAlpha: 1, duration: 0.15, ease: 'power1.out' }); // Ridotto da 0.20 a 0.15
        }
      }, '-=0.05') // Ridotto da -0.10 a -0.05
      // Aggiungo l'animazione di nextCantinaPreview qui, sincronizzata con nextLayer
      .add(() => {
        if (nextCantinaPreview) {
          // Assicurati che l'elemento non abbia ottimizzazioni CSS che interferiscono
          gsap.set(nextCantinaPreview, {
            contain: 'none',
            willChange: 'transform, opacity',
            transform: 'translateZ(0)', // Force GPU acceleration
            backfaceVisibility: 'visible'
          });

          gsap.to(nextCantinaPreview, {
            duration: 0.15, // Sincronizzato con nextLayer
            ease: 'power3.easeOut',
            opacity: 1,
            y: 0,
            zIndex: 9999999,
            force3D: true // Force GPU acceleration
          });
        }
      }, '-=0.05') // Stesso timing di nextLayer per sincronizzazione
      // Nascondi il clone con fade out alla fine di tutta la transizione
      // IMPORTANTE: Nascondi anche l'originale next-hero-bg se ancora visibile
      .to(nextHeroBgClone, {
        opacity: 0,
        duration: 0.2, // Ridotto da 0.3 a 0.2
        ease: 'power2.out',
        onStart: () => {
          // Nascondi anche l'originale next-hero-bg se ancora visibile
          if (nextHeroBg) {
            gsap.set(nextHeroBg, {
              opacity: 0,
              zIndex: 1
            });
          }
        }
      }, '-=0.05'); // Ridotto da -0.1 a -0.05 per iniziare prima
  };

  const scrollTrigger = ScrollTrigger.create({
    trigger: ".wrapper-transition",
    start: "top top", // Cambiato da 47% a 20% per dare più spazio al footer
    end: "bottom bottom",
    pin: ".wrapper-transition",
    pinSpacing: false,
    scrub: true,
    // markers: true,
    // normalizeScroll: true,
    anticipatePin: 1,
    onLeaveBack: () => {
      document.body.style.overflow = '';
      document.documentElement.style.overflow = '';

      if (wrapperTransition) {
        wrapperTransition.style.pointerEvents = '';
        wrapperInteractiveElements.forEach(el => {
          el.style.pointerEvents = '';
        });
      }
      if (spaceTransitionEl) {
        spaceTransitionEl.style.pointerEvents = '';
        spaceInteractiveElements.forEach(el => {
          el.style.pointerEvents = '';
        });
      }
      const pinSpacerEl = document.querySelector('.pin-spacer');
      if (pinSpacerEl) {
        pinSpacerEl.style.pointerEvents = '';
      }
      const header = document.querySelector('#site-header .container');
      if (header) {
        gsap.set(header, {
          backgroundColor: cantinaColor
        });
      }
    },
    onEnter: () => {
      // MIGLIORATO: Assicurati che lo scroll sia abilitato prima di disabilitare pointer-events
      document.body.style.overflow = '';
      document.documentElement.style.overflow = '';

      // if (wrapperTransition) {
      //   wrapperTransition.style.pointerEvents = 'none';
      //   wrapperInteractiveElements.forEach(el => {
      //     el.style.pointerEvents = 'none';
      //   });
      // }
      // if (spaceTransitionEl) {
      //   spaceTransitionEl.style.pointerEvents = 'none';
      //   spaceInteractiveElements.forEach(el => {
      //     el.style.pointerEvents = 'none';
      //   });
      // }
      // const pinSpacerEl = document.querySelector('.pin-spacer');
      // if (pinSpacerEl) {
      //   pinSpacerEl.style.pointerEvents = 'none';
      // }
    },
    onUpdate: self => {
      if (document.body.style.overflow === 'hidden' || document.documentElement.style.overflow === 'hidden') {
        console.warn('⚠️ Scroll bloccato rilevato durante ScrollTrigger.onUpdate - riabilito');
        document.body.style.overflow = '';
        document.documentElement.style.overflow = '';
      }
      const header = document.querySelector('#site-header .container');
      if (header) {
        gsap.set(header, {
          backgroundColor: 'transparent'
        });
      }
      // A questo punto la curtain è confermata in posizione (translateY: 0%)
      if (!opacitySet && nextHeroBg) {
        gsap.set(nextHeroBg, { opacity: 1 });
        opacitySet = true;
        //console.log('✅ ScrollTrigger attivo - next-hero-bg opacity→1 (curtain copre)');
      }
      // Calcola il progress per il reveal (0-100%)
      // La curtain raggiunge 100% prima della fine grazie all'acceleration factor
      const progress = self.progress;

      // Mantieni pointer-events: none sempre quando ScrollTrigger è attivo
      // Questo permette lo scroll anche quando il mouse è fermo su elementi interattivi
      // if (self.isActive) {
      //   if (wrapperTransition) {
      //     wrapperTransition.style.pointerEvents = 'none';
      //     // Rimuovi anche pointer-events: auto dagli elementi interattivi per permettere lo scroll
      //     wrapperInteractiveElements.forEach(el => {
      //       el.style.pointerEvents = 'none';
      //     });
      //   }
      //   if (spaceTransitionEl) {
      //     spaceTransitionEl.style.pointerEvents = 'none';
      //     // Rimuovi anche pointer-events: auto dagli elementi interattivi per permettere lo scroll
      //     spaceInteractiveElements.forEach(el => {
      //       el.style.pointerEvents = 'none';
      //     });
      //   }
      //   const pinSpacerEl = document.querySelector('.pin-spacer');
      //   if (pinSpacerEl) {
      //     pinSpacerEl.style.pointerEvents = 'none';
      //   }
      // }
      const revealPercent = Math.min(progress * 100 * curtainAccelerationFactor, 100);
      const progressBarPercent = progress * 100; // Progress bar avanza con il progresso reale

      // Anima la curtain con translateY diretto (più performante di gsap.set)
      // Ottimizzazione: aggiorna solo se cambiato (evita repaint ridondanti)
      if (curtain && Math.abs(revealPercent - lastCurtainPercent) > 0.1) {
        const curtainPosition = -revealPercent; // Da 0% a -100%
        curtain.style.transform = `translateY(${curtainPosition}%) translateZ(0)`;
        lastCurtainPercent = revealPercent;
      }
      // Aggiorna la progress bar (cached) - usa il progresso reale senza accelerazione
      // Ottimizzazione: aggiorna solo se cambiato significativamente
      if (progressBar && Math.abs(progressBarPercent - lastProgressPercent) > 0.5) {
        progressBar.style.width = `${progressBarPercent}%`;
        lastProgressPercent = progressBarPercent;
      }
      // Controlla se lo scroll ha raggiunto il 100% (usa progress reale)
      if (progress >= 0.99 && !progressBarComplete) {
        progressBarComplete = true;
        setTimeout(() => {
          if (!loading && !shouldTriggerTransition) {
            shouldTriggerTransition = true;
            handleTransition();
          }
        }, 100);
      }
      // Aggiorna z-index pinSpacer (cached)
      if (pinSpacer) {
        pinSpacer.style.zIndex = '99996';
      }
      // Interpolazione loghi (PNG opacity o SVG fill color)
      if (logosCache.length > 0) {
        for (let i = 0; i < logosCache.length; i++) {
          const logoCache = logosCache[i];

          if (logoCache.type === 'png') {
            // PNG: interpola solo opacity del layer accent (MOLTO PIÙ PERFORMANTE!)
            const accentLayer = logoCache.accentLayer;
            if (!accentLayer) continue;

            let targetOpacity;
            if (logoCache.isActive) {
              // Active logo: da 0.8 a 0 (si dissolve)
              targetOpacity = 0.8 * (1 - progress);
            } else if (logoCache.isNextActive) {
              // Next active logo: da 0 a 0.8 (si rivela)
              targetOpacity = 0.8 * progress;
            } else {
              // Altri loghi: sempre 0
              targetOpacity = 0;
            }

            accentLayer.style.opacity = targetOpacity;

          } else if (logoCache.type === 'svg') {
            // SVG: interpola fill color dei paths (fallback legacy, meno performante)
            const paths = logoCache.paths;
            if (!paths || paths.length === 0) continue;

            const activeToOriginal = gsap.utils.interpolate(accentColor, originalColor, progress);
            const originalToActive = gsap.utils.interpolate(originalColor, accentColor, progress);

            let fillColor;
            if (logoCache.isActive) {
              fillColor = activeToOriginal;
            } else if (logoCache.isNextActive) {
              fillColor = originalToActive;
            } else {
              fillColor = originalColor;
            }

            // Applica il colore a tutti i path
            for (let j = 0; j < paths.length; j++) {
              paths[j].style.fill = fillColor;
            }
          }
        }
      }
    },
    onLeave: () => {
      // Quando si esce, riabilita pointer-events prima della transizione
      if (wrapperTransition) {
        wrapperTransition.style.pointerEvents = '';
        // Riabilita pointer-events sugli elementi interattivi
        wrapperInteractiveElements.forEach(el => {
          el.style.pointerEvents = '';
        });
      }
      if (spaceTransitionEl) {
        spaceTransitionEl.style.pointerEvents = '';
        // Riabilita pointer-events sugli elementi interattivi
        spaceInteractiveElements.forEach(el => {
          el.style.pointerEvents = '';
        });
      }
      // pinSpacer viene creato da ScrollTrigger, quindi lo cerchiamo dinamicamente
      const pinSpacerEl = document.querySelector('.pin-spacer');
      if (pinSpacerEl) {
        pinSpacerEl.style.pointerEvents = '';
      }
      handleTransition();
    },
    onRefresh: () => {
      console.log('🔄 ScrollTrigger refreshed');
      // Riabilita scroll in caso di problemi
      document.body.style.overflow = '';
      document.documentElement.style.overflow = '';
    }
  });

  // Salva il trigger per poterlo disabilitare in seguito
  cantScrollTriggers.push(scrollTrigger);

  // Gestione click sugli elementi interattivi quando pointer-events è none
  // Usa event delegation sul document per intercettare i click anche quando pointer-events è none
  const handleInteractiveClick = (e) => {
    // Verifica se il click è su un elemento interattivo dentro wrapper-transition o space-transition
    const target = e.target;
    const isInWrapper = wrapperTransition && wrapperTransition.contains(target);
    const isInSpace = spaceTransitionEl && spaceTransitionEl.contains(target);

    if ((isInWrapper || isInSpace) && scrollTrigger && scrollTrigger.isActive) {
      // Se è un link o un elemento cliccabile, trova l'elemento interattivo più vicino
      const interactiveEl = target.closest('a, button, [data-frecc], .cantina-logo-link');
      if (interactiveEl) {
        // Temporaneamente riabilita pointer-events per permettere il click
        const originalPointerEvents = interactiveEl.style.pointerEvents;
        interactiveEl.style.pointerEvents = 'auto';

        // Crea un nuovo evento click e lo dispatcha sull'elemento
        const clickEvent = new MouseEvent('click', {
          bubbles: true,
          cancelable: true,
          view: window
        });

        // Dispatcha l'evento dopo un breve delay per assicurarsi che pointer-events sia aggiornato
        requestAnimationFrame(() => {
          interactiveEl.dispatchEvent(clickEvent);
          // Rimetti pointer-events a none dopo il click
          interactiveEl.style.pointerEvents = originalPointerEvents || 'none';
        });
      }
    }
  };

  // Aggiungi listener per i click (usa capture phase per intercettare prima)
  document.addEventListener('click', handleInteractiveClick, true);

  // Salva il listener per poterlo rimuovere quando cantScroll viene disabilitato
  scrollTrigger._clickHandler = handleInteractiveClick;

  function lockScroll() {
    const html = document.documentElement;
    const prev = html.style.overflow;
    html.style.overflow = 'hidden';
    return () => { html.style.overflow = prev; };
  }
}